// Mapbox Integration
mapboxgl.accessToken = 'pk.eyJ1Ijoic3lzYWRtaW4tbmNvbC1jb20iLCJhIjoiY21od2Zkdnk3MDY4NzJrb2UwY3R5cWEyOSJ9.r619fjt-RaxCTX18DkN2PQ';

class ReserveInStore extends HTMLElement {
    connectedCallback() {
        if (typeof ncol_api_url === "undefined") return console.error("[Reserve In-Store] Missing API URL.");

        // Setup province names.
        this.provinces = {
            AB: "Alberta",
            BC: "British Columbia",
            MB: "Manitoba",
            NB: "New Brunswick",
            NL: "Newfoundland and Labrador",
            NS: "Nova Scotia",
            NT: "Northwest Territories",
            NU: "Nunavut",
            ON: "Ontario",
            PEI: "Prince Edward Island",
            QC: "Quebec",
            SK: "Saskatchewan",
            YT: "Yukon"
        };

        // Setup Canada bounds.
        this.latLngBounds = {
            north: 70,
            south: 40,
            east: -53,
            west: -141
        };

        // Setup dialog and forms.
        this.opener = this.querySelector("modal-opener");
        this.availableCount = this.querySelector('[data-reserve-in-store="availableCount"]');
        this.dialog = document.querySelector(this.opener.getAttribute("data-modal"));
        this.contactForm = this.dialog.querySelector("form[name='reserveInStore_contact']");
        this.formFeedback = this.contactForm.elements.feedback;

        this.list = {
            form: this.dialog.querySelector('form[name="reserveInStore_selectStore"]'),
            groupByProv: true,
            searchInput: this.dialog.querySelector('[data-reserve-in-store-list="search"]'),
            buttonSearch: this.dialog.querySelector('[data-reserve-in-store-list="button-search"]'),
            buttonMyLocation: this.dialog.querySelector('[data-reserve-in-store-list="button-use-my-location"]'),
            buttonSelectStore: this.dialog.querySelector('[data-reserve-in-store-list="button-select-store"]'),
            options: this.dialog.querySelector('[data-reserve-in-store-list="options"]'),
            template: {
                heading: this.dialog.querySelector('[data-reserve-in-store-list="template-heading"]'),
                list: this.dialog.querySelector('[data-reserve-in-store-list="template-list"]'),
                item: this.dialog.querySelector('[data-reserve-in-store-list="template-item"]')
                // hours: this.dialog.querySelector('[data-reserve-in-store-list="template-hours"]')
            }
        };
        this.list.feedback = this.list.form.querySelector('[name="_feedback"]');

        // Setup selected options.
        this.selected = {
            store: false,
            change: this.contactForm.querySelector('[data-reserve-in-store-selected="change"]'),
            name: this.contactForm.querySelector('[data-reserve-in-store-selected="name"]'),
            address: this.contactForm.querySelector('[data-reserve-in-store-selected="address"]'),
            phone: this.contactForm.querySelector('[data-reserve-in-store-selected="phone"]'),
            hours: this.contactForm.querySelector('[data-reserve-in-store-selected="hours"]'),
            storeNotes: this.contactForm.querySelector('[data-reserve-in-store-selected="storeNotes"]'),
            template: {
                hours: this.contactForm.querySelector('[data-reserve-in-store-selected="template-hours"]')
            }
        };

        this.getAvailableCount();

        // Add event listener for opener.
        this.opener.querySelector('[type="button"]').addEventListener("click", function () {
            this.getStoreLocations();
        }.bind(this));

        // Add store select button.
        this.list.buttonSelectStore.addEventListener("click", this.toggleContactForm.bind(this, true));

        this.selected.change.addEventListener("click", this.toggleContactForm.bind(this, false));

        // Add filter listeners.
        this.list.buttonMyLocation.addEventListener("click", this.useMyLocation.bind(this));
        this.list.form.addEventListener("submit", this.searchList.bind(this));

        // Add submit listeners, and overrides for Enter key.
        this.contactForm.addEventListener("submit", this.onSubmit.bind(this));

        const element = this;
        this.contactForm.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]').forEach(function (input) {
            input.addEventListener("keydown", function (event) {
                if (event.code === "Enter") {
                    event.preventDefault();

                    if (event.originalTarget == element.list.searchInput) return element.searchList(event);

                    element.contactForm.querySelector('button[type="submit"]').click();
                }
            });
        });

        this.setupTurnstile();
    }

    disconnectedCallback() {
        if (this.contactForm.turnstile) turnstile.remove(this.contactForm.turnstile);
    }

    async getAvailableCount() {
        try {
            const availableStores = JSON.parse(`[${this.querySelector('[data-reserve-in-store-data="stores"]').textContent}]`);

            // Fetch location.json
            const fetchRes = await fetch(`${ncol_api_url}/public/api/reservations.json`, { cache: 'no-cache' });
            const data = await fetchRes.json();
            const allStores = data.stores;

            let availableCount = 0;

            allStores.forEach(store => {
                if (!store.reservations_enabled) return;

                // Find store in available stores.
                if (!availableStores.find(item => item.id === store.ext_shopify_id)) return;

                availableCount ++;
            });

            if (!availableCount) {
                this.remove();
                return;
            }

            this.dataset.active = 'true';
            this.availableCount.textContent = `Available for pickup at ${availableCount} store${availableCount == 1 ? '' : 's'}.`;
        } catch (error) {
            console.error(error);
            return;
        }
    }

    async getStoreLocations() {
        this.stores = [];

        try {
            const availableStores = JSON.parse(`[${this.querySelector('[data-reserve-in-store-data="stores"]').textContent}]`);

            // Fetch location.json
            const fetchRes = await fetch(`${ncol_api_url}/public/api/locations.json`, { cache: 'no-cache' });
            const data = await fetchRes.json();
            const allStores = data.stores;

            allStores.forEach(store => {
                if (!store.reservations_enabled) return;

                // Find store in available stores.
                if (!availableStores.find(item => item.id === store.ext_shopify_id)) return;

                this.stores.push(store);
            });
        } catch (error) {
            console.error(error);
            return;
        }

        this.buildStoreItems();
        this.showList();
    }

    buildStoreItems() {
        // Build store item.
        this.stores.forEach(function (store) {
            const listItem = this.list.template.item.content.cloneNode(true);
            const inputId = `field_store_${store.id}`;
    
            // Radio option
            const radio = listItem.querySelector('[data-reserve-in-store-list="radio"]');
            radio.value = store.id;
            radio.id = inputId;
            radio.addEventListener("change", function () {
                this.selected.store = store;
            }.bind(this, store));
    
            const elementThis = this;
            radio.addEventListener('keydown', function (event) {
                if (event.code !== "Enter") return;
                event.preventDefault();
                elementThis.selected.store = store;
                elementThis.toggleContactForm(true);
            });
    
            // Label
            const label = listItem.querySelector('[data-reserve-in-store-list="label"]');
            label.setAttribute("for", inputId);
            listItem.querySelector('[data-reserve-in-store-list="name"]').innerHTML = store.name;
    
            // Address
            listItem.querySelector('[data-reserve-in-store-list="address-short"]').innerHTML = `${store.city}, ${store.province_code}`;
    
            // Hours
            // if (store.store_hours && store.store_hours.length > 0) {
            //     const today = new Date().getDay();
            //     if (store.store_hours[today]) {
            //         const storeHour = store.store_hours[today].split("~");
            //         listItem.querySelector('[data-reserve-in-store-list="hours-today"]').innerHTML = `Today: ${storeHour[1].replace(/\–/, " – ")}`;
            //     }
            // }
    
            label.addEventListener("click", function () {
                radio.selected = true;
                this.selected.store = store;
                this.toggleContactForm(true);
            }.bind(this, store));
    
            store.listItem = listItem.children[0];
        }, this);
    }

    setupTurnstile() {
        const form = this.contactForm;
		const container = this.contactForm.querySelector('[data-turnstile]');

		if (!container) return console.warn('RemoteForm: Turnstile not enabled because container not found.');

        const renderParams = {
            theme: 'light',
            sitekey: cloudflare_turnstile_key,
            action: `ReserveInStore-${form.id}`,
            size: 'compact',
            appearance: 'interaction-only',
            execution: 'execute',
            callback: function(token) {
                form.token = token;
            },
            'before-interactive-callback': function () {
                container.removeAttribute('inert');
            }
        }

        const reserveInStoreElement = this;

        let firstRun = true;
		turnstile.ready(function() {
            if (!firstRun) return;
            firstRun = false;
			form.turnstile = turnstile.render(container, renderParams);

            reserveInStoreElement.executeTurnstile = function() {
                turnstile.execute(container, renderParams);
            };
		});
    }

    haversineCalculation(point1, point2, radius = 6367.5) {
        if (point1.lat) point1.latitude = point1.lat;
        if (point1.lng) point1.longitude = point1.lng;
        if (point2.lat) point2.latitude = point2.lat;
        if (point2.lng) point2.longitude = point2.lng;

        /**
         * @param {number} angle
         */
        function haversine(angle) {
            return 0.5 - Math.cos(angle) / 2;
        }

        /**
         * @param {number} degrees
         */
        function degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        }

        return (2 * radius * Math.asin(Math.sqrt(haversine(degreesToRadians(point2.latitude - point1.latitude)) + Math.cos(degreesToRadians(point1.latitude)) * Math.cos(degreesToRadians(point2.latitude)) * haversine(degreesToRadians(point2.longitude - point1.longitude))))).toFixed(1);
    }

    showList() {
        this.list.options.innerHTML = "";

        if (!this.list.groupByProv) {
            const list = this.list.template.list.content.cloneNode(true).children[0];
            // Sort stores by distance.
            const sortedStores = this.stores.toSorted(function (a, b) {
                return a.distanceToLocation - b.distanceToLocation;
            });
            sortedStores.forEach(function (store) {
                list.appendChild(store.listItem);
            }, this);
            this.list.options.appendChild(list);
            return;
        }

        const availableProvinces = {};
        this.stores.forEach(function (store) {
            if (store.hidden) return;
            if (!availableProvinces[store.province_code]) availableProvinces[store.province_code] = [];
            availableProvinces[store.province_code].push(store.listItem);
        });

        for (const code in this.provinces) {
            if (!availableProvinces[code]) continue;
            const province = availableProvinces[code];
            const list = this.list.template.list.content.cloneNode(true).children[0];
            const heading = this.list.template.heading.content.cloneNode(true).children[0];
            heading.textContent = this.provinces[code];
            this.list.options.appendChild(heading);
            province.forEach(function (store) {
                list.appendChild(store);
            });
            this.list.options.appendChild(list);
        }
    }

    resetList() {
        this.list.groupByProv = true;
        this.stores.forEach(function (store) {
            store.listItem.querySelector('[data-reserve-in-store-list="distance"]').textContent = "";
        }, this);
        this.showList();
    }

    setCurrentLocation(position) {
        const parsedPos = {
            lat: typeof position.lat === "function" ? position.lat() : position.latitude || position.lat,
            lng: typeof position.lng === "function" ? position.lng() : position.longitude || position.lng
        };

        // Update store location distances.
        this.stores.forEach(function (store) {
            const distanceToLocation = this.haversineCalculation(parsedPos, store);
            store.distanceToLocation = distanceToLocation;
            store.listItem.querySelector('[data-reserve-in-store-list="distance"]').textContent = `${store.distanceToLocation} km away`;
        }, this);

        this.list.groupByProv = false;
        this.showList();
    }

    setSearching(searching) {
        this.searching = searching;
        this.list.buttonMyLocation.disabled = searching;
        this.list.buttonSearch.disabled = searching;
        this.list.feedback.removeAttribute('data-status');
        this.list.feedback.textContent = '';

        if (searching) {
            this.list.buttonMyLocation.dataset.loading = "true";
            this.list.buttonSearch.dataset.loading = "true";
        } else {
            this.list.buttonMyLocation.removeAttribute("data-loading");
            this.list.buttonSearch.removeAttribute("data-loading");
        }
    }

    async searchList(event) {
        event.preventDefault();
        if (this.searching) return;

        // If the search value hasn't changed, don't run geocoder.
        const value = this.list.searchInput.value;
        if (!value || value == "") return this.resetList();
        if (this.prevSearch && value === this.prevSearch) return;

        this.setSearching(true);
        this.prevSearch = value;

        try {
            const urlQuery = new URLSearchParams({
                q: value,
                access_token: mapboxgl.accessToken,
                limit: 1,
                country: "ca",
                bbox: `${this.latLngBounds.west},${this.latLngBounds.south},${this.latLngBounds.east},${this.latLngBounds.north}`
            });
            const response = await fetch(`https://api.mapbox.com/search/geocode/v6/forward?${urlQuery.toString()}`);
            const data = await response.json();
            if (!data.features || data.features.length === 0) throw new Error("No results from Mapbox Geocoding API");

            const coordinates = data.features[0].geometry?.coordinates;
            if (!coordinates || coordinates.length < 2) throw new Error("Invalid coordinates from Mapbox Geocoding API");

            const location = {
                lat: coordinates[1],
                lng: coordinates[0]
            };
            this.setCurrentLocation(location);
        } catch (error) {
            console.error(`[Search] ${error}`);
            this.resetList();
        } finally {
            this.setSearching(false);
        }
    }

    useMyLocation() {
        if (this.searching) return;
        this.setSearching(true);
        this.list.searchInput.value = "";

        if (!navigator.geolocation) {
            this.list.feedback.dataset.status = "error";
            this.list.feedback.textContent = 'Your browser does not support geolocation.';
            return this.list.buttonMyLocation.remove();
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.setCurrentLocation(position.coords);
                this.setSearching(false);
            },
            (error) => {
                this.setSearching(false);
                this.list.buttonMyLocation.remove();
                this.list.feedback.dataset.status = "error";
                if (error.code === 1) this.list.feedback.textContent = "You have denied access to your location. Please enter your location manually.";
                else this.list.feedback.textContent = "Unable to get your location. Please enter your location manually.";
                console.error(`[navigator.geolocation]`, error);
            }
        );
    }

    selectStore() {
        if (!this.selected.store) {
            const storeInputs = this.list.form.store;

            if (storeInputs.length)
                storeInputs.forEach(function (radio) {
                    radio.checked = false;
                });
            else storeInputs.checked = false;

            this.list.form.hidden = false;
            this.contactForm.store.value = "";
            this.contactForm.hidden = true;

            this.list.searchInput.focus();
            return;
        }

        const store = this.selected.store;

        // Insert store details
        this.contactForm.store.value = store.ext_shopify_id;
        this.selected.name.innerHTML = store.name;
        this.selected.address.innerHTML = `${store.address1}<br/>${store.address2 ? `${store.address2}<br/>` : ''}${store.city}, ${store.province_code}`;

        // Phone
        const phoneNumber = store.phone.replace(/(?:\+1)*(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.selected.phone.setAttribute('aria-label', `Call store: ${phoneNumber}`);
        this.selected.phone.href = `tel:${store.phone.replace(/\D/g, "")}`;
        this.selected.phone.innerHTML = phoneNumber;

        // Store Notes
        if (store.display_note) this.selected.storeNotes.innerHTML = store.display_note;
        else this.selected.storeNotes.innerHTML = "";

        // Hours
        this.selected.hours.innerHTML = "";
        if (store.store_hours && store.store_hours.length > 0) {
            store.store_hours.forEach(function (item) {
                const storeHour = item.split("~");
                const storeHourElement = this.selected.template.hours.content.cloneNode(true);
                storeHourElement.querySelector("[data-reserve-in-store-selected='hours-day']").innerHTML = storeHour[0];
                storeHourElement.querySelector("[data-reserve-in-store-selected='hours-time']").innerHTML = storeHour[1].replace(/\–/, " – ");
                this.selected.hours.appendChild(storeHourElement);
            }, this);
        } else this.selected.hours.innerHTML = "Call store for current store hours.";

        this.list.form.hidden = true;
        this.contactForm.hidden = false;
    }

    async toggleContactForm(open) {
        if (!open) this.selected.store = false;
        else if (typeof this.executeTurnstile === 'function') this.executeTurnstile();

        if (!document.startViewTransition) {
            this.selectStore();
            return;
        }

        if (!open) document.documentElement.classList.add("transition-back");
        const transition = document.startViewTransition(async () => {
            this.selectStore();
        });

        try {
            await transition.finished;
        } finally {
            document.documentElement.classList.remove("transition-back");
        }
    }

    setSubmitting(submitting) {
        this.submitting = submitting;
        if (submitting) this.contactForm.querySelector('[type="submit"]').setAttribute("disabled", "disabled");
        else this.contactForm.querySelector('[type="submit"]').removeAttribute("disabled");
    }

    async onSubmit(e) {
        e.preventDefault();
        if (this.submitting) return;
        this.setSubmitting(true);

        const formData = new FormData(this.contactForm);

        // Clear all errors.
        this.contactForm.querySelectorAll("[data-error]").forEach((error) => error.remove());
        this.contactForm.querySelectorAll(".field.error").forEach((field) => field.classList.remove("error"));
        this.formFeedback.removeAttribute("data-status");
        this.formFeedback.innerHTML = "";

        try {
            const apiResponse = await fetch(`${ncol_api_url}/api/reserveInStore`, {
                method: "POST",
                body: formData
            });

            const responseData = await apiResponse.json();

            if (responseData.status !== "success") throw responseData;

            this.contactForm.querySelector('[data-reserve-in-store-form="fields"]').remove();
            this.selected.change.remove();

            const successContainer = document.createElement("div");
            successContainer.classList.add("flash", "flash--success", "reserve-in-store__success");

            const successContent = document.createElement("div");
            successContent.classList.add("flash__content");

            const successTitle = document.createElement("h3");
            successTitle.classList.add('flash__title');
            successTitle.textContent = responseData.message || "Your reservation request has been sent!";

            const successMessage = document.createElement("p");
            successMessage.textContent = `${this.selected.store.name} will contact you directly once the item is ready for pickup. If you have any questions, please contact the store directly.`;

            successContent.appendChild(successTitle);
            successContent.appendChild(successMessage);
            successContainer.appendChild(successContent);
            this.contactForm.appendChild(successContainer);
            successContainer.scrollIntoView();
        } catch (error) {
            let firstError = false;
            let genericError = null;
            let formError = "Something went wrong while trying to submit your reservation. Please try again, or contact the store directly.";
            this.formFeedback.dataset.status = "error";

            if (!error.status) {
                this.formFeedback.innerHTML = formError;
                this.formFeedback.scrollIntoView();
                return;
            }

            // If specific fields have errors, show errors on those fields.
            if (error.fields && error.fields.length > 0) {
                error.fields.forEach(function (item) {
                    // Check if field is an actual input.
                    const input = this.contactForm.querySelector(`[name="${item.field}"]`);
                    if (!input) return;

                    // Skip if field is hidden.
                    if (input.type === "hidden") return;

                    // Show generic error if radio option (likely store selection).
                    if (input.type === "radio") {
                        genericError = item.error;
                        return;
                    }

                    // Create error message and add to DOM.
                    const container = input.parentElement;
                    container.classList.add("error");

                    const errorMessage = document.createElement("small");
                    errorMessage.classList.add("form__message", "form__message--error");
                    errorMessage.dataset.error = "true";
                    errorMessage.textContent = item.error;
                    container.after(errorMessage);

                    if (!firstError) firstError = input;
                }, this);
            }

            // If there is a generic error, show it. Scroll to first error or generic one.
            if (genericError || error.message || formError) {
                this.formFeedback.innerHTML = genericError || error.message || formError;
                this.formFeedback.scrollIntoView();
            } else if (firstError) firstError.scrollIntoView();

            if (error.console) console.error("[Reserve In Store] Server Error: ", error.console);
            else if (!error.fields) console.error("[Reserve In Store] Error: ", error);

            if (error.action) {
                if (error.action === "reload") location.reload();
            }

            this.setSubmitting(false);
        }
    }
}

customElements.define("reserve-in-store", ReserveInStore);
